import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../supabaseClient';

export default function Clients() {
    const [clients, setClients] = useState([]);
    const [search, setSearch] = useState('');
    const [editingId, setEditingId] = useState(null);
    const [form, setForm] = useState({ full_name: '', phone: '', type: 'client' });
    const [saving, setSaving] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        fetchClients();
    }, []);

    const fetchClients = async () => {
        const { data, error } = await supabase.from('profiles').select('*').order('full_name', { ascending: true });
        if (error) console.error('Error fetching clients:', error.message);
        else setClients(data || []);
    };

    const filteredClients = clients.filter((client) => {
        const term = search.toLowerCase();
        return client.full_name?.toLowerCase().includes(term) || client.phone?.toLowerCase().includes(term);
    });

    const startEdit = (client) => {
        setEditingId(client.id);
        setForm({ full_name: client.full_name || '', phone: client.phone || '', type: client.type || 'client' });
    };

    const cancelEdit = () => {
        setEditingId(null);
        setForm({ full_name: '', phone: '', type: 'client' });
    };

    const saveClient = async (id, isAdminRow) => {
        setSaving(true);
        const payload = isAdminRow ? { full_name: form.full_name, phone: form.phone } : { full_name: form.full_name, phone: form.phone, type: form.type };
        const { error } = await supabase.from('profiles').update(payload).eq('id', id);
        setSaving(false);
        if (error) {
            alert('Error al guardar: ' + error.message);
            return;
        }
        setClients((prev) => prev.map((c) => (c.id === id ? { ...c, ...payload } : c)));
        setEditingId(null);
    };

    const deleteClient = async (id) => {
        if (!window.confirm('¿Seguro que querés eliminar este cliente?')) return;

        const { data, error } = await supabase.from('profiles').delete().eq('id', id).select();

        console.log('deleted:', data);
        console.log('error:', error);

        if (error) {
            alert('Error al eliminar: ' + error.message);
            return;
        }
        if (data?.length === 0) {
            alert('No se borró nada — probablemente RLS está bloqueando');
            return;
        }

        setClients((prev) => prev.filter((c) => c.id !== id));
    };

    return (
        <section className='w-[95%] md:w-[90%] lg:w-[80%] mx-auto py-6'>
            <div className='mb-4'>
                <input type='text' placeholder='Buscar por nombre o teléfono...' value={search} onChange={(e) => setSearch(e.target.value)} className='w-full md:w-1/2 border border-sand bg-cream text-ink rounded px-3 py-2' />
            </div>

            {/* Desktop */}
            <div className='hidden md:block overflow-x-auto rounded border border-sand'>
                <table className='w-full table-auto border-collapse text-sm'>
                    <colgroup>
                        <col style={{ width: '18%' }} />
                        <col style={{ width: '14%' }} />
                        <col style={{ width: '24%' }} />
                        <col style={{ width: '10%' }} />
                        <col style={{ width: 'auto' }} />
                    </colgroup>
                    <thead>
                        <tr className='bg-sand text-left text-terracotta-dark'>
                            <th className='border px-4 py-2'>Nombre</th>
                            <th className='border px-4 py-2'>Teléfono</th>
                            <th className='border px-4 py-2'>Email</th>
                            <th className='border px-4 py-2'>Rol</th>
                            <th className='border px-4 py-2 text-center whitespace-nowrap'>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredClients.map((client) => {
                            const isEditing = editingId === client.id;
                            return (
                                <tr key={client.id} className='hover:bg-sand/40'>
                                    <td className='border px-3 py-2'>
                                        {isEditing ? <input value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} className='border border-sand bg-cream text-ink rounded px-2 py-1 w-full' /> : client.full_name}
                                    </td>
                                    <td className='border px-3 py-2'>
                                        {isEditing ? <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className='border border-sand bg-cream text-ink rounded px-2 py-1 w-full' /> : client.phone || '—'}
                                    </td>
                                    <td className='border px-3 py-2'>{client.email || '—'}</td>
                                    <td className='border px-3 py-2'>
                                        {isEditing && client.type !== 'admin' ? (
                                            <select
                                                value={form.type}
                                                onChange={(e) => setForm({ ...form, type: e.target.value })}
                                                className='border border-sand bg-cream text-ink rounded px-2 py-1 w-full'
                                            >
                                                <option value='client'>Cliente</option>
                                                <option value='staff'>Staff</option>
                                            </select>
                                        ) : client.type === 'admin' ? (
                                            'Admin'
                                        ) : client.type === 'staff' ? (
                                            'Staff'
                                        ) : (
                                            'Cliente'
                                        )}
                                    </td>
                                    <td className='border px-3 py-2 text-center whitespace-nowrap'>
                                        <div className='flex justify-center gap-2'>
                                            {!isEditing ? (
                                                <button onClick={() => startEdit(client)} className='bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600'>
                                                    Editar
                                                </button>
                                            ) : (
                                                <>
                                                    <button disabled={saving} onClick={() => saveClient(client.id, client.type === 'admin')} className='bg-terracotta text-cream px-3 py-1 rounded hover:bg-terracotta-dark'>
                                                        {saving ? 'Guardando...' : 'Guardar'}
                                                    </button>
                                                    <button onClick={cancelEdit} className='bg-sand text-ink px-3 py-1 rounded hover:bg-sand/70'>
                                                        Cancelar
                                                    </button>
                                                </>
                                            )}
                                            <button onClick={() => navigate(`/admin/bonus/${client.id}/${client.full_name}`)} className='bg-purple-600 text-white px-3 py-1 rounded hover:bg-purple-700'>
                                                Bonos
                                            </button>
                                            <button onClick={() => navigate(`/admin/profileclasses/${client.id}/${client.full_name}`)} className='bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700'>
                                                Clases
                                            </button>
                                            <button onClick={() => deleteClient(client.id)} title='Eliminar' aria-label='Eliminar' className='bg-red-500 text-white w-7 h-7 flex items-center justify-center rounded hover:bg-red-600'>
                                                ×
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                        {filteredClients.length === 0 && (
                            <tr>
                                <td colSpan={5} className='text-center py-4'>
                                    No hay resultados.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Mobile */}
            <div className='md:hidden space-y-3'>
                {filteredClients.map((client) => {
                    const isEditing = editingId === client.id;
                    return (
                        <div key={client.id} className='border border-sand rounded-lg p-4 shadow-sm bg-card'>
                            <div className='space-y-2'>
                                <div className='flex gap-2'>
                                    <span className='w-[40%] text-sm font-medium text-ink/70'>Nombre</span>
                                    {isEditing ? (
                                        <input value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} className='border border-sand bg-cream text-ink rounded px-2 py-1 w-[60%]' />
                                    ) : (
                                        <span className='w-[60%]'>{client.full_name}</span>
                                    )}
                                </div>
                                <div className='flex gap-2'>
                                    <span className='w-[40%] text-sm font-medium text-ink/70'>Teléfono</span>
                                    {isEditing ? (
                                        <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className='border border-sand bg-cream text-ink rounded px-2 py-1 w-[60%]' />
                                    ) : (
                                        <span className='w-[60%]'>{client.phone || '—'}</span>
                                    )}
                                </div>
                                <div className='flex gap-2'>
                                    <span className='w-[40%] text-sm font-medium text-ink/70'>Email</span>
                                    <span className='w-[60%] text-sm'>{client.email || '—'}</span>
                                </div>
                                <div className='flex gap-2 items-center'>
                                    <span className='w-[40%] text-sm font-medium text-ink/70'>Rol</span>
                                    {isEditing && client.type !== 'admin' ? (
                                        <select
                                            value={form.type}
                                            onChange={(e) => setForm({ ...form, type: e.target.value })}
                                            className='border border-sand bg-cream text-ink rounded px-2 py-1 w-[60%]'
                                        >
                                            <option value='client'>Cliente</option>
                                            <option value='staff'>Staff</option>
                                        </select>
                                    ) : (
                                        <span className='w-[60%] text-sm'>{client.type === 'admin' ? 'Admin' : client.type === 'staff' ? 'Staff' : 'Cliente'}</span>
                                    )}
                                </div>
                            </div>

                            <div className='mt-4 flex gap-2'>
                                {!isEditing ? (
                                    <button onClick={() => startEdit(client)} className='px-3 py-2 rounded border w-full text-yellow-700 border-yellow-300'>
                                        Editar
                                    </button>
                                ) : (
                                    <>
                                        <button onClick={() => saveClient(client.id, client.type === 'admin')} disabled={saving} className='px-3 py-2 rounded border w-[50%] text-terracotta border-terracotta/40'>
                                            {saving ? 'Guardando...' : 'Guardar'}
                                        </button>
                                        <button onClick={cancelEdit} className='px-3 py-2 rounded border w-[50%] text-ink border-sand hover:bg-sand/40'>
                                            Cancelar
                                        </button>
                                    </>
                                )}
                            </div>

                            <div className='mt-3 flex justify-between gap-2'>
                                <button onClick={() => navigate(`/admin/bonus/${client.id}/${client.full_name}`)} className='px-3 py-2 rounded border flex-1 text-purple-700 border-purple-200'>
                                    Bonos
                                </button>
                                <button onClick={() => navigate(`/admin/profileclasses/${client.id}/${client.full_name}`)} className='px-3 py-2 rounded border flex-1 text-blue-700 border-blue-200'>
                                    Clases
                                </button>
                                <button onClick={() => deleteClient(client.id)} title='Eliminar' aria-label='Eliminar' className='w-9 h-9 flex items-center justify-center rounded border text-red-700 border-red-200'>
                                    ×
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </section>
    );
}
